<a routerLink="/shows/{{show.slug}}/podcasts">
  <picture
    responsive
    [src]="show.logo_square || show.logo1"
    [width]="250"
    [nativeWidth]="250"
    [nativeHeight]="250"
    alt="Logo"
    ></picture>

  <div class="name">
    <div>
      {{show.name}}
    </div>
  </div>
</a>